import React, { useState, useRef, useMemo } from "react";
import { observer } from "mobx-react";
import { Autocomplete, Select, Button } from "@ann/web-components";
import {
  FiltersContainer,
  SearchContainer
} from "./Filters.styled";

const Filters = observer(() => {
  const [searchValue, setSearchValue] = useState("");
  const [searchKey, setSearchKey] = useState(0);
  const [searchTermStatus, setSearchTermStatus] = useState("");
  const [searchTermLastUpdate, setSearchTermLastUpdate] = useState("");
  const [filtersKey, setFiltersKey] = useState(0);
  const autocompleteRef = useRef(null);

  // Filter options
  const statusOptions = [
    { label: "Sent", value: "sent" },
    { label: "Delivered", value: "delivered" },
    { label: "Read", value: "read" },
    { label: "Failed", value: "failed" },
    { label: "Pending", value: "pending" },
    { label: "Bounced", value: "bounced" },
    { label: "Spam", value: "spam" },
    { label: "Scheduled", value: "scheduled" },
  ];

  const lastUpdateOptions = [
    { label: "Last 7 days", value: "last_7_days" },
    { label: "Last 30 days", value: "last_30_days" },
    { label: "This month", value: "this_month" },
    { label: "This year", value: "this_year" },
  ];

  // Filtered options based on search terms
  const filteredStatus = useMemo(() => {
    if (!searchTermStatus.trim()) return statusOptions;
    const searchLower = searchTermStatus.toLowerCase();
    return statusOptions.filter(
      (option) =>
        option.label.toLowerCase().includes(searchLower) ||
        option.value.toLowerCase().includes(searchLower)
    );
  }, [searchTermStatus]);

  const filteredLastUpdate = useMemo(() => {
    if (!searchTermLastUpdate.trim()) return lastUpdateOptions;
    const searchLower = searchTermLastUpdate.toLowerCase();
    return lastUpdateOptions.filter(
      (option) =>
        option.label.toLowerCase().includes(searchLower) ||
        option.value.toLowerCase().includes(searchLower)
    );
  }, [searchTermLastUpdate]);

  const handleSearchChange = (value) => {
    setSearchValue(value);
    // Here you can add your search logic or call a callback function
    // to update the parent component's state
  };

  const handleSearchClear = () => {
    setSearchValue("");
    setSearchKey((prev) => prev + 1);

    if (autocompleteRef.current) {
      const input = autocompleteRef.current.querySelector("input");
      if (input) {
        input.value = "";
        input.dispatchEvent(new Event("input", { bubbles: true }));
      }
    }
  };

  const handleStatusChange = (items) => {
    // Handle status filter changes
    console.log("Status filter changed:", items);
  };

  const handleLastUpdateChange = (items) => {
    // Handle last update filter changes
    console.log("Last update filter changed:", items);
  };

  const handleClearAllFilters = () => {
    setSearchValue("");
    setSearchTermStatus("");
    setSearchTermLastUpdate("");
    setSearchKey((prev) => prev + 1);
    setFiltersKey((prev) => prev + 1);

    // Clear autocomplete input
    if (autocompleteRef.current) {
      const input = autocompleteRef.current.querySelector("input");
      if (input) {
        input.value = "";
        input.dispatchEvent(new Event("input", { bubbles: true }));
      }
    }
  };

  const emptyOrValue = (arr) => (arr.length > 0 ? arr : undefined);

  return (
    <FiltersContainer>
      <SearchContainer>
        <Autocomplete
          key={searchKey}
          ref={autocompleteRef}
          value={searchValue}
          onChange={handleSearchChange}
          onSearch={() => { }}
          onSuggestionSelect={() => { }}
          onClear={handleSearchClear}
          placeholder="Search SMS..."
          suggestions={[
            "Incoming SMS",
            "Outgoing SMS",
            "Support SMS",
            "Marketing SMS",
            "Notification SMS",
            "Verification SMS",
            "Alert SMS",
          ]}
        />
      </SearchContainer>
      <Select
        key={`status-filter-${filtersKey}`}
        label="Status"
        placeholder="Status"
        onChange={handleStatusChange}
        size="small"
        value={undefined}
        width="auto"
        minWidth="60px"
      >
        <Select.Menu>
          {filteredStatus.map((status) => (
            <Select.Item
              key={status.value}
              value={status.value}
              label={status.label}
            >
              {status.label}
            </Select.Item>
          ))}
        </Select.Menu>
      </Select>
      <Select
        key={`last-update-filter-${filtersKey}`}
        label="Last Update"
        placeholder="Last Update"
        onChange={handleLastUpdateChange}
        size="small"
        value={undefined}
        width="auto"
        minWidth="60px"
      >
        <Select.Menu>
          {filteredLastUpdate.map((option) => (
            <Select.Item
              key={option.value}
              value={option.value}
              label={option.label}
            >
              {option.label}
            </Select.Item>
          ))}
        </Select.Menu>
      </Select>
      <Button
        icon=""
        iconLeft=""
        iconRight=""
        label="Clear Filters"
        size="medium"
        type="secondary"
        onClick={handleClearAllFilters}
      />
    </FiltersContainer>
  );
});

export default Filters; 